import { render, staticRenderFns } from "./package_history_item.vue?vue&type=template&id=1934d544&scoped=true&"
import script from "./package_history_item.vue?vue&type=script&lang=js&"
export * from "./package_history_item.vue?vue&type=script&lang=js&"
import style0 from "./package_history_item.vue?vue&type=style&index=0&id=1934d544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1934d544",
  null
  
)

export default component.exports